import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InsideLook } from './components/InsideLook';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { WhoItsFor } from './components/WhoItsFor';
import { Guarantee, Footer } from './components/Footer';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-8 text-center" data-id="element-0" data-mp="31b8j3x6zk98o">
    <div className="gold-rule mb-4" aria-hidden="true" data-id="element-1" data-mp="31ctd9lpe1q60">
      <span className="text-brand-gold text-xs" data-id="element-2" data-mp="2wiyy8vkq9zd9">◆</span>
    </div>
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed" data-id="element-3" data-mp="28ufoebm15ej2">
      La prossima lezione può essere più semplice da guidare.
    </p>
  </div>;
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full text-brand-text font-sans selection:bg-brand-gold/25 selection:text-brand-purpleDark" data-id="element-4" data-mp="3ijftvw9y1qd1">
      <UrgencyBanner data-id="element-5" data-mp="3mj6lg27aoaim" />
      <main data-id="element-6" data-mp="3rbra6pbcfxfa">
        <Hero data-id="element-7" data-mp="3rbzngibdp4r0" />
        <InsideLook data-id="element-8" data-mp="3rdkgg3i1ofmr" />
        <PackContents data-id="element-9" data-mp="3rd18nfm3z7mg" />
        <PainPoints data-id="element-10" data-mp="5yjetptzbev" />
        <MethodOverview data-id="element-11" data-mp="6hovayao7c0" />
        <Guarantee data-id="element-12" data-mp="4n53zyrel9i" />
        <FAQ data-id="element-13" data-mp="56lvdcob3ly" />
        <WhoItsFor data-id="element-14" data-mp="7su7f7e1n58" />
        <TransitionPhrase data-id="element-15" data-mp="2zld0l5ad579f" />
        <EmotionalClose data-id="element-16" data-mp="2zm4yimrfnh2v" />
      </main>
      <Footer data-id="element-17" data-mp="2zn69yscd25l4" />
    </div>;
}